import axiosOverlay from './axiosOverlay'
import useUserStore from '@/stores/user'

export default function axiosOverlayConnector(axiosConfig, overlayConfig = {}) {
  let userStore = useUserStore()

  let functionConfig = {
    getToken: () => {
      return userStore.token
    },
    setToken: (token) => {
      userStore.token = token
    },
    logout() {
      import('@/router').then(({ default: router }) => {
        userStore.logout().finally(() => {
          router.push({ name: 'login' })
        })
      })
    },
    errorsHandlers: {
      default: ({ error, reject }) => {
        console.log(error)
        reject(error)
      },
      401: async ({ error, overlayConfig, reject, retry, resolve }) => {
        // Si on a un refresh token valide, on tente de rafraîchir
        if (userStore.isRefreshTokenValid) {
          try {
            // Appel du refresh token avec mustBeAuthenticated false pour éviter la boucle
            const refreshUrl = import.meta.env.VITE_API_URL + '/auth/refresh-token'
            const refreshConfig = {
              url: refreshUrl,
              method: 'POST',
              data: {
                refreshToken: userStore.refreshToken
              }
            }

            // Utilise axiosOverlay directement avec mustBeAuthenticated: false
            // et sans les handlers personnalisés pour éviter la boucle
            const response = await axiosOverlay(refreshConfig, {
              retry: false,
              functions: {
                ...overlayConfig.functions,
                errorsHandlers: {
                  default: ({ error, reject }) => {
                    reject(error)
                  }
                }
              }
            })

            // Met à jour les tokens
            userStore.token = response.data.accessToken
            if (response.data.refreshToken) {
              userStore.refreshToken = response.data.refreshToken
            }

            // Retry la requête originale avec le nouveau token
            const result = await retry()
            resolve(result)
          } catch (refreshError) {
            // Le refresh token a échoué (401 ou autre), on déconnecte l'utilisateur
            userStore.token = null
            userStore.refreshToken = null

            if (overlayConfig.allowRedirect) {
              import('@/router').then(({ default: router }) => {
                router.push({ name: 'login' })
              })
            }
            reject(refreshError)
          }
        } else {
          // Pas de refresh token valide, on déconnecte
          userStore.token = null
          userStore.refreshToken = null

          if (overlayConfig.allowRedirect) {
            import('@/router').then(({ default: router }) => {
              router.push({ name: 'login' })
            })
          }
          reject(error)
        }
      },
      498: ({ error, overlayConfig, reject }) => {
        // Token invalide ou expiré de manière définitive
        if (overlayConfig.allowRedirect) {
          import('@/router').then(({ default: router }) => {
            userStore.token = null
            userStore.refreshToken = null
            router.push({ name: 'login' })
          })
        }
        reject(error)
      }
    }
  }

  if (!overlayConfig.functions) overlayConfig.functions = {}

  // overwrite functionConfig with overlayConfig.functions
  overlayConfig.allowRedirect = true
  overlayConfig.functions = { ...functionConfig, ...overlayConfig.functions }
  overlayConfig.functions.errorsHandlers = {
    ...functionConfig.errorsHandlers,
    ...overlayConfig.functions.errorsHandlers
  }
  overlayConfig.functions.errorsConfig = {
    ...functionConfig.errorsConfig,
    ...overlayConfig.functions.errorsConfig
  }

  return axiosOverlay(axiosConfig, overlayConfig)
}
